import Vue from 'vue'



// 用于全局的公共函数
const baseFun = {
  // 本地存储
  localSet(obj, key) {
    var newObj = obj;
    var str = JSON.stringify(newObj);
    localStorage.setItem(key, str);
  },
  localGet(key) {
    var str = localStorage.getItem(key);
    return JSON.parse(str);
  },
  localClear(key) {
    localStorage.removeItem(key);
  },
  getIsGZH(){//获取登录用户
    return window.localStorage.getItem('isGzh');
  },
  delIsGZH(){//获取登录用户
    window.localStorage.removeItem('isGzh');
  },
  getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
  },
  getLoginUser(){//获取登录用户


      if(window.localStorage.getItem('user')){
        return JSON.parse(window.localStorage.getItem('user'));
      }

    return '';
  },
  setLoginUser(user){//设置登录用户
    window.localStorage.setItem('user',JSON.stringify(user));
  },
  delLoginUser(){//删除登录用户
    window.localStorage.removeItem('user');
  },
    hasAdminRole(){
       let user = this.getLoginUser();
        let self = this;
        if (user.roles) {
            let roles = user.roles.split(";");
            for (var i = 0; i < roles.length; i++) {
                if (roles[i] == 'ADMIN' || roles[i] == 'SUPER_ADMIN') {
                  return true;
                }
            }
        }
        return false;
    }

}


//导出模块
export default {
  baseFun,
}





// WEBPACK FOOTER //
// ./src/api/baseFun.js